// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__19qPY","cell":"ColumnAccessor_cell__nh-C1","firstCellAccent":"ColumnAccessor_firstCellAccent__3ReXS"};